/*
 * Keeps the PayPal Pay Later message on the product page in sync with the selected
 * variant's price.
 *
 * PayPal's messages component attaches its own observer to every `data-pp-*`
 * attribute on the element it rendered into, so updating `data-pp-amount` is enough —
 * calling `render()` again would draw a second message.
 * https://developer.paypal.com/docs/checkout/pay-later/us/integrate/advanced-js-options/
 *
 * Rendered only on eligible storefronts (see snippets/paypal-pay-later-message.liquid),
 * so this file is never requested on the other markets.
 */
(function () {
  var container = document.querySelector('[data-paypal-pay-later]');
  if (!container) return;

  var message = container.querySelector('[data-pp-message]');
  if (!message) return;

  // pubsub.js / constants.js are deferred in the head, so they have run by now. Guard
  // anyway: a missing pub/sub must leave the initial server-rendered amount standing,
  // never blank the message.
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var variant = event && event.data && event.data.variant;

    if (!variant || typeof variant.price !== 'number' || variant.price <= 0) {
      container.hidden = true;
      return;
    }

    container.hidden = false;

    // variant.price is in the presentment currency's minor units (cents).
    var amount = (variant.price / 100).toFixed(2);
    if (message.getAttribute('data-pp-amount') !== amount) {
      message.setAttribute('data-pp-amount', amount);
    }
  });
})();
